import { backgroundOrange } from '@/theme/colors'
import styled, { keyframes } from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	background-color: ${backgroundOrange};
`

export const Card = styled.div`
	width: 100%;
	max-width: 420px;
	background: white;
	border: 1px solid #e1e5e9;
	border-radius: 12px;
	padding: 2rem;
	box-shadow: 0 2px 10px rgba(16, 24, 40, 0.06);
	text-align: center;
`

export const Title = styled.h1`
	margin: 0 0 0.5rem 0;
	font-size: 1.5rem;
	color: #101828;
`

export const Subtitle = styled.p`
	margin: 0 0 1.5rem 0;
	color: #475467;
	font-size: 0.875rem;
`

export const Divider = styled.div`
	display: flex;
	align-items: center;
	margin: 1.5rem 0;
	color: #98a2b3;
	font-size: 0.875rem;

	&::before,
	&::after {
		content: '';
		flex: 1;
		border-bottom: 1px solid #e1e5e9;
	}

	&::before {
		margin-right: 1rem;
	}

	&::after {
		margin-left: 1rem;
	}
`

export const QrSection = styled.div`
	margin-top: 1rem;
`

export const QrTitle = styled.p`
	margin: 0 0 1rem 0;
	color: #344054;
	font-size: 0.875rem;
	font-weight: 500;
`

export const QrContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.5rem;
	background: #f9fafb;
	border: 1px solid #e1e5e9;
	border-radius: 8px;
	min-height: 280px;
`

const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`

export const LoadingSpinner = styled.div`
	width: 48px;
	height: 48px;
	border: 4px solid #e1e5e9;
	border-top: 4px solid #ff6b35;
	border-radius: 50%;
	animation: ${spin} 1s linear infinite;
`

export const QrCodeWrapper = styled.div`
	background: white;
	padding: 1rem;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1);
`

export const QrInstruction = styled.p`
	margin: 0.75rem 0 0 0;
	color: #667085;
	font-size: 0.75rem;
	line-height: 1.4;
`
